module.exports = __webpack_public_path__ + "img/hero.c2e1d575.jpg";